<template>
  <div class="defaultView">
    <TopMenu page="рассказ" url="/stories/upload" @sort="sort" />
    <div class="list">
      <BlockView
        v-for="dates in models"
        v-bind:key="dates.id"
        v-bind:dates="dates"
        routeName="stories-edit"
      ></BlockView>
    </div>
  </div>
</template>

<script>
import BlockView from "@/components/BlockView.vue";
import TopMenu from "@/components/TopMenu.vue";
import stories from "@/composables/views/stories.ts";

export default {
  setup() {
    const { getStories, models } = stories();
    return {
      getStories,
      models,
    };
  },
  data() {
    return {};
  },
  name: "StoriesView",

  components: {
    BlockView,
    TopMenu,
  },
  mounted: function () {},
  methods: {
    async sort(type) {
      console.log(type);
    },
  },
  async created() {
    this.getStories();
  },
};
</script>
